import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { useSiteContent } from "@/contexts/SiteContent";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1582672060674-bc2bd808a8f5?auto=format&fit=crop&w=1800&q=85";

export default function About() {
  const content = useSiteContent();
  const cfg = content?.home_about || {};
  const pillars = cfg.pillars || [
    { n: "01", title: "Discretion",  body: "Off-market mandates reach a curated buyer list before any public release." },
    { n: "02", title: "Provenance",  body: "Direct relationships with master developers and branded-residence ateliers." },
    { n: "03", title: "Stewardship", body: "Concierge through purchase, residency, family-office, and onward exit." },
  ];
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-36 bg-[#f5f0e8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <SectionHeading
              title={<>{cfg.title_line_1 || "A private house"}<br />{cfg.title_line_2 || "for those who do"}<br />{cfg.title_line_3_prefix || "not "}<em className="not-italic text-[#3d2b1f]">{cfg.title_line_3_emphasis || "browse"}</em>.</>}
              subtitle={cfg.subtitle || "The Vision"}
            />
            <p className="mt-8 text-[#3d2b1f] text-base max-w-md leading-relaxed">
              {cfg.paragraph || "AZEFAC Properties represents fewer than ninety High-Net-Worth principals at any given moment. We do not list inventory — we curate residences for the people we know, in the places they belong."}
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/about"
                data-testid="home-about-cta-story"
                className="inline-flex items-center gap-3 px-6 py-3 border border-[#c5a059]/60 text-[#c5a059] uppercase text-[10px] tracking-[0.32em] hover:bg-[#c5a059] hover:text-[#1c1c1c] transition-colors"
              >
                Our Story <ArrowUpRight size={13} />
              </Link>
              <Link
                to="/vision"
                data-testid="home-about-cta-ceo"
                className="inline-flex items-center gap-3 px-6 py-3 border border-[#1c1c1c]/30 text-[#1c1c1c] uppercase text-[10px] tracking-[0.32em] hover:bg-[#1c1c1c] hover:text-[#f5f0e8] transition-colors"
              >
                CEO Message <ArrowUpRight size={13} />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="img-zoom aspect-[5/6] mb-12">
              <img
                src={ABOUT_IMG}
                alt="Burj Al Arab — Dubai skyline editorial"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="space-y-10">
              {pillars.map((p) => (
                <div
                  key={p.n}
                  data-testid={`pillar-${p.n}`}
                  className="grid grid-cols-12 gap-6 pb-10 border-b border-[#1c1c1c]/10 last:border-0"
                >
                  <div className="col-span-2 font-display text-3xl text-[#c5a059]">{p.n}</div>
                  <div className="col-span-10">
                    <h3 className="font-display text-2xl text-[#1c1c1c] mb-3">{p.title}</h3>
                    <p className="text-[#3d2b1f] text-sm leading-relaxed">{p.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
